const AtaturkCornerWidget = {
    getHTML: function () {
        const imgPath = new URL('../../assets/images/ataturk_kosesi/ataturk_main.jpg', import.meta.url).href;
        return `
            <div id="ataturk-corner-widget" class="portal-card ataturk-card" onclick="window.openAtaturkCorner()">
                <div class="portal-card-header">
                    <span class="portal-card-icon">❤️</span>
                    <h2 class="portal-card-title">ATATÜRK KÖŞESİ</h2>
                </div>
                <div class="ataturk-content">
                    <img src="${imgPath}" alt="Mustafa Kemal Atatürk" class="ataturk-img">
                    <div class="ataturk-quote-box">
                        <p id="ataturk-widget-quote" class="ataturk-quote">"Türk milleti çalışkandır, Türk milleti zekidir."</p>
                    </div>
                </div>
                <div class="portal-card-footer">
                    <span class="portal-card-link">İNCELEMEK İÇİN TIKLA <span class="arrow-blink">➤</span></span>
                </div>
            </div>
        `;
    },

    init: function () {
        if (window.TeableQuestionService && typeof window.TeableQuestionService.fetchAtaturkQuotes === 'function') {
            window.TeableQuestionService.fetchAtaturkQuotes().then(quotes => {
                const quoteEl = document.getElementById('ataturk-widget-quote');
                if (quoteEl && quotes.length > 0) {
                    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
                    quoteEl.textContent = `"${randomQuote}"`;
                }
            }).catch(err => console.warn("Widget Quote Error:", err));
        }

        window.openAtaturkCorner = function () {
            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');
            if (window.ui && window.ui.showScreen) {
                window.ui.showScreen('ataturk-corner-screen');
            }
        };
    }
};

window.AtaturkCornerWidget = AtaturkCornerWidget;
export { AtaturkCornerWidget };
